import { useState } from 'react';
import toast from 'react-hot-toast';
import { reportErrorToUser } from 'src/api/axiosClient/errorHandling';
import { getApiErrorMessage } from 'src/api/axiosClient/errorParser';
import { useAdminCompaniesApi } from '../api';
import {
  AdjustFreeCreditsDialogProps,
  AdjustFreeCreditsDialogViewModel,
  AdjustFreeCreditsFormData,
} from '../types';

const initFormData: AdjustFreeCreditsFormData = {
  freeCredits: 0,
  reason: '',
};

export const useAdjustFreeCreditsDialogController = (
  props: AdjustFreeCreditsDialogProps,
): AdjustFreeCreditsDialogViewModel => {
  const { open, company, onClose, onAdjusted, initialFormData } = props;
  const { giveCompanyFreeCredits } = useAdminCompaniesApi();

  // Not closable while the request is out: whatever opened the dialog acts on the result
  const [submitting, setSubmitting] = useState(false);

  const submit = async (data: AdjustFreeCreditsFormData) => {
    setSubmitting(true);
    try {
      await giveCompanyFreeCredits(company.id, {
        freeCredits: data.freeCredits,
        reason: data.reason.trim(),
      });
    } catch (e) {
      reportErrorToUser(e, getApiErrorMessage(e, 'Failed to adjust free credits'));
      return;
    } finally {
      setSubmitting(false);
    }

    toast.success('Free credits updated');
    onClose();
    await onAdjusted();
  };

  return {
    open,
    formData: initialFormData ?? initFormData,
    balance: company.freeCreditsRemaining,
    close: submitting ? undefined : onClose,
    submit,
  };
};
